import React, { useEffect, useState } from 'react';
import moment from "moment";
import {
    Badge,
    // Button,
    Card,
    Row,
    Col,
    Container,
    // Breadcrumb,
    Image,
} from 'react-bootstrap';
// import { MdClose, MdFileCopy, MdNewLabel } from 'react-icons/md';
import { convertCurrency, convertLogicticsName, convertPriceWithCommission, formatOrderCreator, imageRender, numberFormat } from '../../../helpers';
import { GET_EXCHANGRATE } from '../../../graphql/exchangeRate/Query';
import { useLazyQuery } from '@apollo/client';
import { convertOrderStatus, convertOrderType } from '../../../helpers/orderStatus';
import { COLOR_WHITE } from '../../../constants';
import { FaLuggageCart } from 'react-icons/fa';

export default function OrderDetails({ selectedOrderGroup }) {

    const [shopRate, setShopRate] = useState()

    const order = {
        orderId: "0876432",
        status: "pending",
        items: [
            {
                id: "1",
                name: 'iPad Pro 11"',
                specs: ['Space-gray', '256GB'],
                price: 999.0,
                quantity: 1,
                image: '/placeholder.svg',
            },
            {
                id: "2",
                name: 'Airpods Pro',
                specs: ['White'],
                price: 249.0,
                quantity: 1,
                image: '/placeholder.svg',
            },
            {
                id: "3",
                name: 'Macbook Pro 14"',
                specs: ['Space-gray', '16GB', '1TB'],
                price: 1999.0,
                quantity: 1,
                image: '/placeholder.svg',
            },
        ],
        delivery: {
            address: '2626 Rockwell Lane Apt. 120',
            city: 'Overland Park',
            country: 'US',
            phone: '913-664-1217',
            method: 'Free (12 days)',
            estimatedDate: 'Mar 12, 2024',
        },
        summary: {
            subtotal: 2914.2,
            discount: 323.8,
            delivery: 0,
            tax: 291.42,
            total: 3205.62,
        },
    };


    const [getExchangeRate, { data: loadExchangeRate, loading: loadingExchangeRate }] = useLazyQuery(GET_EXCHANGRATE, { fetchPolicy: "cache-and-network" });

    useEffect(() => {
        if (loadExchangeRate) {
            setShopRate(loadExchangeRate?.exchangeRate)
        }

    }, [loadExchangeRate])

    //   fetch exchange ret
    useEffect(() => {
        if (selectedOrderGroup?.shop?.id) {
            getExchangeRate({
                variables: {
                    where: {
                        shop: selectedOrderGroup?.shop?.id,
                    },
                },
            });
        }
    }, [selectedOrderGroup]);


    return (
        <Container className="py-4">

            {/* Order Header */}
            <Row className="mb-4">
                <Col>
                    <Image style={{ width: 80, height: 80 }} src={imageRender(selectedOrderGroup?.customerImage)} alt='customer-profile' thumbnail referrerPolicy="no-referrer" />
                    <h6>ລູກຄ້າ: {selectedOrderGroup?.cfName ?? selectedOrderGroup?.customerName ?? "-"}</h6>
                    <p>ເບີໂທ: {selectedOrderGroup?.phone ?? "-"}</p>
                    <p>ວັນທີ,ເດືອນ,ປີ {selectedOrderGroup?.createdAt ? moment(selectedOrderGroup.createdAt).format("YYYY/MM/DD HH:mm:ss") : "-"}</p>
                    {selectedOrderGroup?.creator && (
                      <p>ສ້າງໂດຍ: {formatOrderCreator(selectedOrderGroup.creator)}</p>
                    )}
                    {selectedOrderGroup?.isOT && (
                      <p>ປະເພດບິນ: <Badge bg="warning" text="dark">OT</Badge></p>
                    )}
                    <p>ການຊຳລະ:  <Badge bg={selectedOrderGroup?.isPaymented ? "success" : "danger"}> {selectedOrderGroup?.isPaymented ? "ຊຳລະແລ້ວ" : "ຍັງບໍ່ຊຳລະ"}</Badge></p>
                    <p>ຫົວຂໍ້: {selectedOrderGroup?.live?.description ?? "-"}</p>
                    <p>ທວງຍອດ: {selectedOrderGroup?.isClaimBalance ? "ທວງຍອດແລ້ວ" : "ຍັງບໍທວງຍອດ"}</p>
                    <p>ຈ່າຍຄ່າເຄື່ອງ: {selectedOrderGroup?.orderDelivery?.shipmentPayType === "COD" ? "ປາຍທາງ" : "ຕົ້ນທາງ"}</p>
                    <p>ສະຖານະອໍເດີ້: {convertOrderStatus(selectedOrderGroup?.status)}</p>
                    <p>ປະເພດ: {convertOrderType(selectedOrderGroup?.type)}</p>
                </Col>
                <Col>
                    <p>ໃບສະລີບໂອນເງິນລູກຄ້າ</p>
                    <Image src={imageRender(selectedOrderGroup?.paySlip)} style={{ maxWidth: 160 }} alt='paySlip' />
                </Col>

            </Row>
            <hr />

            {/* Order Items */}
            <Card style={{ boxShadow: 'none', border: 'none', background: COLOR_WHITE }} className="mb-4">
                <Card.Body>
                    <Card.Text>
                        ລາຍການອໍເດີ້
                    </Card.Text>
                    {selectedOrderGroup?.orders.map((item) => (
                        <Row key={item.id} className="align-items-center mb-3 border-bottom">
                            <Col md={2}>
                                <Image
                                    src={imageRender(item?.stock?.image?.[0] ?? item?.stocks?.image)}
                                    alt={item?.cfMessage}
                                    className="img-fluid rounded"
                                    style={{ width: 60 }}
                                />
                            </Col>
                            <Col md={6}>
                                <h5>{item?.productName} </h5>
                                <p className="text-muted">ລະຫັດ: {item?.cfMessage || item?.stock?.cfMessage}</p>
                            </Col>
                            <Col md={2} className="text-end">
                                <p>{convertCurrency(item?.currency)} {numberFormat(item?.totalPrice)}</p>
                            </Col>
                            <Col md={2} className="text-end">
                                <p>ຈຳນວນ: ({item?.amount})</p>
                            </Col>
                        </Row>
                    ))}
                </Card.Body>
            </Card>

            <Row>
                {/* Delivery Information */}
                <Col md={6}>
                    <Card style={{ boxShadow: 'none' }} className="mb-4">
                        <Card.Body>
                            <h5>
                                ຂົນສົ່ງ {convertLogicticsName(
                                    selectedOrderGroup?.orderDelivery?.delivery || selectedOrderGroup?.logistic || ""
                                )}
                            </h5>
                            <p>
                                <strong>ເລກຕິດຕາມພັດສະດຸ:</strong> {selectedOrderGroup?.orderDelivery?.deliveryTackingNo ?? "-"}
                            </p>

                            {selectedOrderGroup?.orderDelivery?.id ? <p>
                                <strong>ບ່ອນຈັດສົ່ງ:</strong> ({selectedOrderGroup?.orderDelivery?.receiver?.branchCode ?? "-"}), {selectedOrderGroup?.orderDelivery?.receiver?.province}, {selectedOrderGroup?.orderDelivery?.receiver?.district},{' '}
                                {selectedOrderGroup?.orderDelivery?.receiver?.branch}
                            </p> :
                                <p>
                                    <strong>ບ່ອນຈັດສົ່ງ: {selectedOrderGroup?.destinationLogistic ?? "-"} </strong> 
                                </p>
                            }

                            <p className="text-success">
                                <FaLuggageCart style={{ fontSize: 28, marginRight: 6 }} />
                                ຂົນສົ່ງອື່ນໆ: {selectedOrderGroup.addressCf ?? ""}
                            </p>
                        </Card.Body>
                    </Card>
                </Col>


                {/* Order Summary */}
                <Col md={6}>
                    <Card style={{ boxShadow: 'none' }}>
                        <Card.Body>
                            <h5>ຂໍ້ມູນສະຫຼູບ</h5>
                            <Row className="mb-2 text-muted">
                                <Col>ລວມກີບ:</Col>
                                <Col className="text-end">{numberFormat(selectedOrderGroup?.totalPrice ?? 0)}</Col>
                            </Row>
                            <Row className="mb-2 text-muted">
                                <Col>ລວມບາດ:</Col>
                                <Col className="text-end">{numberFormat(selectedOrderGroup?.sumPriceBaht ?? 0)}</Col>
                            </Row>
                            <Row className="mb-2 text-muted">
                                <Col>ລວມໂດລາ:</Col>
                                <Col className="text-end">{numberFormat(selectedOrderGroup?.sumPriceUsd ?? 0)}</Col>
                            </Row>
                            <Row className="mb-2 text-muted">
                                <Col>Tax:</Col>
                                <Col className="text-end">0</Col>
                            </Row>
                            <hr />
                            <Row className="fw-bold">
                                <Col>ຍອດເງິນທີ່ຈ່າຍ:</Col>
                                <Col className="text-end">{numberFormat(convertPriceWithCommission(selectedOrderGroup?.totalPrice, selectedOrderGroup?.sumPriceBaht, selectedOrderGroup?.sumPriceUsd, 0, shopRate))} ກີບ</Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>




            </Row>
        </Container>
    );
}
